import { render } from "./AchievementHistorySection.vue?vue&type=template&id=2d9bbdbd&scoped=true"
import script from "./AchievementHistorySection.vue?vue&type=script&lang=js"
export * from "./AchievementHistorySection.vue?vue&type=script&lang=js"

import "./AchievementHistorySection.vue?vue&type=style&index=0&id=2d9bbdbd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d9bbdbd"]])

export default __exports__